// import home from './pages/home.vue';
import NotFound from './components/NotFound.vue';
import passwordGenerator from './pages/passwordGenerator.vue'
import toolsHome from './pages/toolsHome.vue'


export default {
  routes: [
    { path: '/', component: toolsHome },
    { path: '/tools', component: toolsHome },
    // { path: '/home', component: home },
    { path: '/tools/passwordGenerator', component: passwordGenerator },
    { path: '*', component: NotFound }
  ]
}